import type { UserId } from "./users.interface";
import type { IRoleUserMapping } from "./role-user-mapping.interface";

export interface ICardsCount {
    total: number;
    totalByRole: IRoleUserMapping;
}

export type ICardsCountByUser = Map<UserId, ICardsCount>;

export function makeCardsCount(): ICardsCount {
    return { total: 0, totalByRole: Object.create(null) };
}
